export const isPhoneScreen = () => window.matchMedia("only screen and (max-width: 668px)").matches;
export const isPortrait = () => window.matchMedia("(orientation: portrait)").matches;
export const isLandscape = () => window.matchMedia("(orientation: landscape)").matches;

export const isIE = !!document.documentMode;

export const isEdge = /Edge/.test(navigator.userAgent);

export const isMSBrowser = isIE || isEdge;

export const isFirefox = /Firefox/i.test(navigator.userAgent);

export const isSafari =
  navigator.vendor &&
  navigator.vendor.indexOf("Apple") > -1 &&
  navigator.userAgent &&
  !navigator.userAgent.match("CriOS");

export const isAndroid = /android/i.test(navigator.userAgent);

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);

export const isPhone = () => isMobile && isPhoneScreen();
export const isPhonePortrait = () => isPhone() && isPortrait();
export const isPhoneLandscape = () => isPhone() && isLandscape();

export const isTablet = () => isMobile && !isPhoneScreen();
